// src/components/SwitchablePage.jsx
import React, { useState, useEffect } from 'react'
import '../CSS_stuff/Lore2_format.css'; // see CSS below
import SuggestedReadingOrder from '../Pages/SuggestedReadingOrder';

// maps
import lore1  from "../assets/Map-Taridawil.jpg";
import lore2  from "../assets/MAP-Brelsin.jpg";
import lore3  from "../assets/MAP-Dawil.jpg";
import lore4  from "../assets/MAP-Ilseador.jpg";
import lore5  from "../assets/MAP-MerutianSea-DIPZA.jpg";
import lore6  from "../assets/MAP-MerutianSea-fromKotR3-HJ2.jpg";
import lore7  from "../assets/MAP-Pathremir-Daffyds.jpg";
import lore8  from "../assets/MAP-TallspireFromSide.jpg";
import lore9  from "../assets/MAP-TallspireFromTop.jpg";
import lore10 from "../assets/MAP-Taridawil-with-vassal-fiefs.jpg";

//Timeline import
import timeline from "../assets/2025-Timeline.jpg";
//Importing the read order
import OrderRead from "../assets/2025-reading-order.jpg";

export default function Lore() {
  // this next part is used to make it so that I can go to a spicific part of this page

  // map from the raw hash to your view names
  const hashToView = {
    '':           'gallery',
    gallery:      'gallery',
    timeline:     'Timeline',
    'read-order':'Read order',
  }

  // 1) Initialize view based on the URL hash
  const initialHash = window.location.hash.slice(1).toLowerCase();
  const [view, setView] = useState(
    hashToView[initialHash] || 'gallery'
  );

  // 2) Listen for hashchange events (back/forward / manual edits)
  useEffect(() => {
    const onHashChange = () => {
      const key = window.location.hash.slice(1).toLowerCase();
      setView(hashToView[key] || 'gallery');
    };

    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // 3) Helper to switch tab + update URL hash
  const goToView = (hash, viewName) => {
    if (window.location.hash.slice(1) !== hash) {
      window.location.hash = hash;
    }
    setView(viewName);
  };

  const nextSlide = () =>
    setCurrentSlide(i => (i + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide(i => (i - 1 + slides.length) % slides.length);

  // State for slider
  const [currentSlide, setCurrentSlide] = useState(0);


  // Sample images for the gallery
  const slides = [
    { src: lore1,  title: "Map of Taridawil" },
    { src: lore2,  title: "Map of Brelsin" },
    { src: lore3,  title: "Map of Dawil" },
    { src: lore4,  title: "Map of Ilseador" },
    { src: lore5,  title: "Map of Merutian Sea" },
    { src: lore6,  title: "Map of Merutian Sea from An Entirely-Unexpected Revelation" },
    { src: lore7,  title: "Map of Pathremir" },
    { src: lore8,  title: "Map of Tallspire from side" },
    { src: lore9,  title: "Map of Tallspire from top" },
    { src: lore10, title: "Map of Taridawil with vassal fiefs" }
  ];


  return (
    <div className="switcher-container">
      <div className="button-group">
        <button
          className={view === 'gallery' ? 'active' : ''}
          onClick={() => goToView('gallery', 'gallery')}
        >
          Gallery of Maps
        </button>
        <button
          className={view === 'Timeline' ? 'active' : ''}
          onClick={() => goToView('timeline', 'Timeline')}
        >
          TimeLine
        </button>
        <button
          className={view === 'Read order' ? 'active' : ''}
          onClick={() => goToView('read-order', 'Read order')}
        >
          Suggested Reading Order
        </button>
      </div>

      <div className="content-area">
        {view === 'gallery' && (
          <>
            <div className="lore-slider">
              <h3 className="slide-title">{slides[currentSlide].title}</h3>
              <button className="lore-nav prev" onClick={prevSlide}>
                ‹
              </button>
                
              {slides.map((s, i) => (
                <img
                  key={i}
                  src={s.src}
                  alt={s.title}
                  className={
                    i === currentSlide ? 'slide active' : 'slide'
                  }
                  loading="lazy"
                />
              ))}

              <button className="lore-nav next" onClick={nextSlide}>
                ›
              </button>
            </div>

            <div className="lore-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={i === currentSlide ? 'dot active' : 'dot'}
                  onClick={() => setCurrentSlide(i)}
                />
              ))}
            </div>
          </>
        )}

        {view === 'Timeline' && (
          <div className="Timeline-page">
            <img
              src={timeline}
              alt="This is a timeline of the books"
              className="page-image"
            />
          </div>
        )}

        {view === 'Read order' && (
          <div className="Read-order-page">
            <SuggestedReadingOrder />
          </div>
        )}
      </div>
    </div>
  );
}
